import type { IConsentConfig, IConsentGroup } from '../types/IConsentConfig';
import { essentialServicesGroup } from './essentialServiceGroup';
import { formularConsentGroup } from './formularGroup';
import { socialMediaConsentGroup } from './socialMediaGroup';
import { trackingConsentGroup } from './trackingConsentGroup';
import { videoConsentGroup } from './videoConsentGroup';

export const consentGroups: Array<IConsentGroup | IConsentConfig> = [
  essentialServicesGroup,
  trackingConsentGroup,
  videoConsentGroup,
  socialMediaConsentGroup,
  formularConsentGroup,
];
